var Base = require('_js/base'),
  $ = require('jquery'),
  ko = require('knockout');

function BureauSubscriptionItem(params, parent) {
  this.parent = parent;
  this.name = ko.observable(params.name || '');
  this.contact = ko.observable(params.contact || '');
  this.email = ko.observable(params.email || '');
  this.postalCode = ko.observable(params.postalCode || '');
  this.address = ko.observable(params.address || '');
}

BureauSubscriptionItem.prototype.editItem = function() {
  this.parent.editSubscription(this);
};
BureauSubscriptionItem.prototype.removeItem = function() {
  this.parent.askRemoveSubscription(this);
};

function BureauSubscriptionList(params) {
  // Create a temporary array which we can populate with items.
  var totalSubscriptions = [];
  for (var i = 0; i < params.subscriptions.length; i++) {
    totalSubscriptions.push(
      new BureauSubscriptionItem(params.subscriptions[i], this)
    );
  }

  // Current page.
  this.currentPage = ko.observable(1);
  this.itemsPerPage = 5;
  this.totalPages = ko.computed(function() {
    var pages = Math.ceil(totalSubscriptions.length / this.itemsPerPage);
    if (pages < 1) {
      pages = 1;
    }
    return Math.ceil(pages);
  }, this);

  this.currentPage.subscribe(function(value) {
    this.subscriptions(
      totalSubscriptions.slice(
        (value - 1) * this.itemsPerPage,
        value * this.itemsPerPage
      )
    );
  }, this);

  // Create an observable that will watch the first page of items.
  this.subscriptions = ko.observableArray(
    totalSubscriptions.slice(0, this.itemsPerPage)
  );
  // This is the subscription shown in the (edit) modal.
  // If it is empty, we will show the "add" subscription instead.
  this.emptySubscription = new BureauSubscriptionItem({}, this);
  this.activeSubscription = ko.observable(this.emptySubscription);

  // States to show/hide the two modals.
  this.modalActive = ko.observable(false);
  this.deleteModal = ko.observable(false);
}

BureauSubscriptionList.prototype.changePage = function(index) {
  this.currentPage(index);
};

BureauSubscriptionList.prototype.editSubscription = function(subscription) {
  this.activeSubscription(subscription);
  this.openModal();
};

BureauSubscriptionList.prototype.addSubscription = function() {
  this.activeSubscription(this.emptySubscription);
  this.openModal();
};

BureauSubscriptionList.prototype.askRemoveSubscription = function() {
  // We do not want both modals open.
  this.modalActive(false);
  this.deleteModal(true);
};

BureauSubscriptionList.prototype.cancelRemove = function() {
  this.deleteModal(false);
};

BureauSubscriptionList.prototype.openModal = function() {
  this.modalActive(true);
};

BureauSubscriptionList.prototype.closeModal = function() {
  this.modalActive(false);
};

function BureauSubscription() {
  this.init();
}

BureauSubscription.prototype = new Base();

BureauSubscription.prototype.init = function() {
  var $bureauSubscriptions = $('[data-bureau-subscriptions]');
  if ($bureauSubscriptions.get(0) !== undefined) {
    ko.applyBindings(
      new BureauSubscriptionList(
        $bureauSubscriptions.data('bureau-subscriptions')
      ),
      $bureauSubscriptions.get(0)
    );
  }
};

module.exports = BureauSubscription;
